import {
    SidebarGroup, SidebarGroupContent, useSidebar,
} from "@/components/ui/sidebar"

import logo from '@/assets/logo_fekvo_feher.svg';
import logoIcon from '@/assets/logo_ikon_feher.svg';

export function Branding() {
    const sidebar = useSidebar()

    return (
        <SidebarGroup>
            <SidebarGroupContent>
                <div className={"flex gap-2 items-center justify-center"}>
                    <img src={sidebar.open ? logo : logoIcon} alt={"logo"} className={"w-2/3"}/>
                </div>
            </SidebarGroupContent>
        </SidebarGroup>
    )
}
